import React, { useState } from 'react';
import axios from 'axios';

const Newsletter = () => {
  const list = 2; // Compass?
  const [email, setEmail] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [message, setMessage] = useState(null);
  const [status, setStatus] = useState(null);
  // const [recaptcha, setRecaptcha] = useState(false);

  const submitNewsletter = e => {
    e.preventDefault();

    const data = {
      email,
      listId: list,
      first_name: 'finite scroll',
      last_name: 'test user',
      double_opt_in: false
    };

    const validEmail = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9.]+$/gm.test(
      data.email
    );

    if (validEmail) {
      axios
        .post('https://tempo.inc.com/getrevue/add/', data, {
          headers: {
            Authorization: 'Token iHKTPKgaDUSYFKnbsZlEnbPT119pM-3e'
          }
        })
        .then(res => {
          if (res.status === 200) {
            setDisabled(true);
            setMessage('You are now subscribed to Compass!');
            setStatus('success');
          }
        });
    } else {
      setDisabled(false);
      setMessage('Invalid email address, please try again.');
      setStatus('fail');
    }
  };

  return (
    <section className="finite-scroll__newsletter">
      <div className="label">
        Innovation <span>in your inbox.</span>
      </div>

      <input
        type="email"
        placeholder="Enter your email for the daily newsletter, Compass."
        onKeyUp={e => setEmail(e.currentTarget.value)}
        onFocus={() => setMessage(null)}
        disabled={disabled}
      />

      <button onClick={e => submitNewsletter(e)}>Sign Up</button>

      {message && <div className={`message ${status}`}>{message}</div>}
    </section>
  );
};

export default Newsletter;
